module.exports = __webpack_public_path__ + "img/top7.194d3f89.png";